// @flow
import React, {Component} from 'react';
import { type Match } from 'react-router-dom';
import MainMobileHeadContainer from 'containers/main/MainMobileHeadContainer';
import MainHeadContainer from 'containers/main/MainHeadContainer';
import MainMobileFooter from 'components/main/MainMobileFooter';
import SettingsTemplate from 'components/settings/SettingsTemplate';
import SettingSections from 'containers/settings/SettingSections';
import PageTemplate from "components/base/PageTemplate";

type Props = {
  match: Match,
};

class Settings extends Component<Props> {
  render() {
    const { match } = this.props;
    return (
      <PageTemplate>
        <header>
          <MainHeadContainer />
          <MainMobileHeadContainer />
        </header>
        <SettingsTemplate form={<SettingSections type={match.params.tab || 'user'} />} />
        <MainMobileFooter />
      </PageTemplate>
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/pages/Settings.js